import { render, staticRenderFns } from "./creditsAndRefundsMobile.vue?vue&type=template&id=64d5b69b&scoped=true&"
import script from "./creditsAndRefundsMobile.vue?vue&type=script&lang=js&"
export * from "./creditsAndRefundsMobile.vue?vue&type=script&lang=js&"
import style0 from "./creditsAndRefundsMobile.vue?vue&type=style&index=0&id=64d5b69b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5b69b",
  null
  
)

export default component.exports